module.exports = __webpack_public_path__ + "img/taken_shipping.cf1d24df.svg";